module.exports = __webpack_public_path__ + "assets/ase-alt.11fbaf41.svg";